import TemplateMixin from './TemplateMixin';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class ChatTemplate extends Mixins(TemplateMixin) {
  @Prop({ default: null })
  themeId: number;

  $refs: {
    widgetIframe: HTMLIFrameElement;
  };

  @Watch('chatUrl')
  themeIdWatcher() {
    if (this.$refs.widgetIframe) this.$refs.widgetIframe.contentWindow.location.reload();
  }

  get chatUrl(): string {
    const token = this.userSLWidgetToken || this.widgetToken;
    if (!token) return '';

    const chatBaseUrl = `${process.env.MIX_STREAMLABS_URL}/widgets/studio/chat-box/v1/${token}`;

    return `${chatBaseUrl}${!this.component.useSLSettings && this.themeId ? `/${this.themeId}` : ''}${this.isEditor ? '?simulate=true' : ''}`;
  }
}
